import { render, staticRenderFns } from "./NewPostulationOmil.vue?vue&type=template&id=1d982d34&scoped=true"
import script from "./NewPostulationOmil.vue?vue&type=script&lang=ts"
export * from "./NewPostulationOmil.vue?vue&type=script&lang=ts"
import style0 from "./NewPostulationOmil.vue?vue&type=style&index=0&id=1d982d34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d982d34",
  null
  
)

export default component.exports